import { positiveAmount } from './activities/gameplay.mjs';
export const systemActivityTypes = ['FRIEND_WHEEL', 'PROMOTION_GIFT', 'PROMOTION_BONUS', 'INVITE_FRIEND_V1', 'INVITE_FRIEND_V2', 'BALANCE_TREASURE', 'BALANCE_TREASURE_INTEREST', 'BALANCE_TREASURE_TASK'];
// 展示分类不改变首存玩法。保留入口辅助契约以兼容组件调用。
export function isDisplayOnlyFirstDeposit() {
  return false;
}
export function isDepositActivity(activity) {
  return ['FIRST_DEPOSIT', 'REDEPOSIT'].includes(activity?.activityType);
}
// 仅控制入口回显；到账凭证、申请周期和防重均由服务端再次核验。
export function redepositCycleStart(cycle, now = Date.now()) {
  const date = new Date(now + 8 * 3600000);
  if (!['DAILY', 'WEEKLY', 'MONTHLY'].includes(cycle)) return null;
  const day = cycle === 'MONTHLY' ? 1 : date.getUTCDate() - (cycle === 'WEEKLY' ? (date.getUTCDay() + 6) % 7 : 0);
  return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), day) - 8 * 3600000;
}
export function activityEntry(activity, data, platform) {
  if (isDisplayOnlyFirstDeposit(activity)) return { message: '请查看活动内容，具体参与方式以活动说明为准。' };
  const h5 = platform === 'h5';
  const match = (item) => Number(item?.activityId) === Number(activity.id);
  switch (activity.activityType) {
    case 'REDEPOSIT': {
      const start = redepositCycleStart(activity.applicationCycle);
      if (start === null || !activity.content) return { message: '续存活动领取规则尚未完整配置，请等待配置完成。' };
      const record = (data?.data || []).find((row) => Number(row.activityId) === Number(activity.id) && Number(row.claimedAt) * 1000 >= start);
      if (record) return { message: '本周期已有续存参与记录，请查看领取记录。', claimed: true, details: [`${record.rewardName || '续存奖励'}：${record.rewardAmount}元`] };
      const eligibility = data?.eligibility;
      if (String(eligibility?.activityId) !== String(activity.id) || eligibility.eligible !== true) return { message: eligibility?.reason || '正在核对续存资格，请刷新查询。' };
      if (!positiveAmount(eligibility.rewardAmount)) return { message: '奖励预估暂不可用，请刷新领取资格。' };
      return { message: '按本申请周期内单笔实际到账金额核验续存，首笔存款不计入续存。每个周期限领一次，奖励发至中心钱包。', details: [`预计奖励：${eligibility.rewardAmount}元，提交时再次核验。`], action: 'firstDepositClaim', label: '校验续存并领取' };
    }
    case 'FIRST_DEPOSIT': {
      const record = (data?.data || []).find((row) => Number(row.activityId) === Number(activity.id));
      return record
        ? { message: Number(record.status) === 2 ? '首存奖励已到账，请查看领取记录。' : '已有首存参与记录，请核对处理状态。', details: [`${record.rewardName || '首存奖励'}：${record.rewardAmount}元`], claimed: true }
        : !activity.content ? { message: '首存活动领取规则尚未公布，请等待活动配置完成。' }
        : { message: '首存活动采用申请流程，活动申请暂未开放，请稍后再试。' };
    }
    case 'PROMOTION_GIFT':
      if (!match(data) || (Number(data.enabled) !== 1 && Number(data.applied) !== 1)) return { message: '本活动暂未开放申请' };
      return {
        label: data.applied === 1 ? '查看豪礼申请进度' : '查看资格并申请豪礼',
        route: h5 ? '/pages/vip/index' : '/member/gift',
        message: data.applied === 1 ? ({ PENDING: '已申请，待发货', SHIPPED: '已发货', COMPLETED: '已完成' }[data.applicationStatus] || '已申请') : data.eligible === 1 ? '您已满足等级条件，可进入豪礼页面选择奖品并填写收货资料。' : '您暂未满足等级条件，可查看晋级要求。',
        details: [data.memberLevelName && `当前等级：${data.memberLevelName}`, ...(data.rewardNames || []).map((name) => `奖品：${name}`), data.trackingNo && `物流：${data.logisticsCompany || ''} ${data.trackingNo}`].filter(Boolean)
      };
    case 'PROMOTION_BONUS': {
      const rules = (data?.data || []).filter(match).filter((rule) => Number(rule.enabled) === 1);
      if (!rules.length) return { message: '本活动暂未开放领取' };
      return { label: '查看晋级彩金规则与领取记录', route: h5 ? '/pages/vip/index' : '/member/vip', message: '按会员等级查看可领取规则，选择活动场馆后申请，到账结果以领取记录为准。', details: ['最低转账金额、彩金比例、上限和流水要求以对应等级规则为准。'] };
    }
    case 'BALANCE_TREASURE':
    case 'BALANCE_TREASURE_INTEREST':
      return { label: '查看余额宝规则与记录', route: h5 ? '/pages/balance-treasure/index' : '/member/balance-treasure', message: '在余额宝查看账户、收益、转账及任务记录，参与条件以专属规则为准。' };
    case 'BALANCE_TREASURE_TASK':
      return { label: '查看余额宝任务与记录', route: h5 ? `/pages/balance-treasure/index?tab=task&activityId=${encodeURIComponent(activity.id)}` : `/member/balance-treasure?tab=task&activityId=${encodeURIComponent(activity.id)}`, message: '查看当前余额宝任务，参与条件以任务规则为准。' };
    case 'INVITE_FRIEND_V1':
    case 'INVITE_FRIEND_V2':
      if (!match(data) || !(data.inviteLink || data.invitationLink)) return { message: '本活动暂无可用邀请入口' };
      return { label: '分享邀请并查看奖励进度', route: h5 ? `/pages/share/index?activityId=${encodeURIComponent(activity.id)}` : 'invitation', message: '使用本人的邀请链接分享，好友达标后可查看奖励进度。', details: [`已邀请注册：${data.registeredCount || 0}人`, `已达标：${data.qualifiedCount || 0}人`, `已获得奖励：${data.rewardAmount || '0.00'}`] };
    default:
      return { message: '查看下方开放的奖品及申请进度。' };
  }
}
